import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { emailValidator } from 'src/app/theme/utils/app-validators';
import { ApiService } from 'src/app/shared/services/api.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {
  storeDetails: Object;
  contactForm: FormGroup;

  constructor(
    public formBuilder: FormBuilder,
    private apiService: ApiService
  ) { }

  ngOnInit() {
    this.contactForm = this.formBuilder.group({
      name: ['', Validators.required],
      email: ['', Validators.compose([Validators.required, emailValidator])],
      phone: ['', Validators.required],
      message: ['', Validators.required]
    });
    this.apiService.getStoreDetails().subscribe(data => {
      if(data['response']['status'] === 1) {
        this.storeDetails = data['response']['data']['store'];
      }
    }, err => console.log('error', err))
  }

  public onContactFormSubmit(values:Object):void {
    if (this.contactForm.valid) {
    }
  }

}
